import * as React from 'react'

import cn from '@/utils/tailwind/cn'

export type SidebarProps = {
  withBottomPadding?: boolean
  withPadding?: boolean
} & React.HTMLAttributes<HTMLDivElement>
export const SidePanel = ({
  withBottomPadding,
  withPadding,
  className,
  ...props
}: SidebarProps) => (
  <div
    className={cn(
      'h-full w-[400px] overflow-auto border !border-l-0 !border-t-0 border-border bg-white',
      withBottomPadding && 'pb-[300px]',
      withPadding && 'p-4',
      className
    )}
    {...props}
  />
)
